import gql from 'graphql-tag';

export const GET_LENDER_SUBMISSIONS_REPORT = gql`
  query LenderRetailActivitySubmissionsReport($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      lenderSubmissionsReport(input: $input) {
        success
        error
        entity {
          creditSubmissionId
          createdDateTime
          customerName
          lenderName
          loanType
          model
          vin
          term
          status
          lenderDecision
          declineReason
          approvedAmount
          financedAmount
          timeOfDecision
          notes
        }
      }
    }
  }
`;
